<template>
    <div class="content" ref="content" v-loading="loading" element-loading-text="刷新中...">
        <div>
            <div class="list-header"></div>
            <div class="list-box scroll-body" >
                <el-row :gutter="20" class="list">
                    <el-col :span="4" class="ranking-title">排名</el-col>
                    <el-col :span="16" class="name-title">昵称</el-col>
                    <el-col :span="4" class="score-title">得分</el-col>
                </el-row>
                <el-row v-for="(item, index) in data" :key="index" :gutter="20" class="list">
                    <el-col :span="4" class="ranking">{{ index + 1 }}</el-col>
                    <el-col :span="16" class="name">
                        <i class="iconfont icon-touxiang" v-if="!item.headurl" :class="{'Rank-one': index == 0,'Rank-two': index == 1,'Rank-three': index == 2}"></i>
                        <img v-else :src="item.headurl == 'touxiang.png' ? defaultAvatar : item.headurl" alt="头像">
                        <p class="user-name" :style="{color: item.activeUser ? '#409EFF' : ''}">{{item.nickname}}</p>
                    </el-col>
                    <el-col :span="4" class="score">{{item.score}}</el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RankingList',
    data() {
        return{
            Height: '',
            radioRule: 0,
            data: [],
            loading: false,
            defaultAvatar: require('@/assets/default-imgs/touxiang.png')
        }
    },
    computed:{
        back() {
            return this.$route.query.isBack
        },
        id: {
            get() {
                return this.getQueryStringhash('id')
            },
            set(){}
        }
    },
    created() {
        this.id = sessionStorage.getItem("examId")
        this.getList()
    },
    mounted() {
        this.Height = `${document.documentElement.clientHeight - 100}px`
    },
    methods: {
        // 获取参数 带#
        getQueryStringhash(key) {
            let after = window.location.hash.split("?")[1];
            if (after) {
                let reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
                let r = after.match(reg);
                if (r != null) {
                    return decodeURIComponent(r[2]);
                }
                else {
                    return null;
                }
            }
        },
        goBack() {
            this.$router.go(-1)
        },
        getList() {
            let that = this
            let params = {
                that: this,
                url: `${this.$config.service.examRanking}?id=${that.id}&rule=${that.radioRule}`,
                method: "POST",
                cb(res) {
                    console.log(res)
                    if (res.code == '0'){                          
                        res.resultBody.forEach((info) => {
                            if (info.headurl && (info.headurl.indexOf('http') == -1 || info.headurl.indexOf('https') == -1)){
                                info.headurl = info.headurl
                            }
                            if (that.$route.query.userId == info.underwayId) {
                                that.$set(info, 'activeUser', true)
                            }
                        })
                        that.data = res.resultBody  
                        that.loading = false
                    }
                },
            };
            params.isnologin = true
            this.$util.request(params);
        }
    }
}
</script>

<style scoped lang="scss">
.content{
    // margin:20px 20px 20px 100px;
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100vw;
    height: 100vh;
    background-color: #f1f1f1;
    // padding: 20px;
    box-sizing: border-box;
    /deep/.el-card{
        border: none;
        height: inherit;
    }
    .page-header{
        margin-bottom: 30px;
    }
    .list-header{
        height: 150px;
        background: url('../../assets/rankingList.png') no-repeat center;
        background-size: contain;
    }
    .list-box{
        padding: 10px 10px;
        box-sizing: border-box;
        background-color: hsl(240, 6%, 97%);
        color: #bfbfc0;
        height: calc(100vh - 150px);
        overflow-y: auto;
        .list{
            padding: 10px 0;
            box-sizing: border-box;
            font-size: 14px;
            display: flex;
            align-items: center;
            .ranking-title,.score-title{
                text-align: center;
            }
            .name-title{
                margin-left: 10px;
            }
            .ranking{
                font-size: 16px;
                text-align: center;
            }
            .score{
                color: #4e4e4f;
                font-size: 16px;
                font-weight: bold;
                text-align: center;
            }
            .name{
                color: #4e4e4f;
                display: flex;
                align-items: center;
                .icon-touxiang{
                    display: inline-block;
                    width: 40px;
                    height: 40px;
                    font-size: 40px;
                    margin-right: 10px;
                    color:#9f9f9f;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                }
                .user-name{
                    margin-left: 10px;
                    word-break: break-all;
                    height: 40px;
                    line-height: 40px;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .Rank-one{
                    border: 1px solid #f3b346;
                }
                .Rank-two{
                    border: 1px solid #dbdddf;
                }
                .Rank-three{
                    border: 1px solid #eca061;
                }
            }
            
        }
    }
    .settings-box{
        background-color: rgba(242, 242, 242, 1);
        padding: 40px 30px;
        box-sizing: border-box;
        .leaderboard-settings{
            font-size: 24px;
            color: #333333;
            font-weight: 650;
        }
        .radio-rule{
            padding: 25px 0;
            box-sizing: border-box;
            margin: 20px 0;
            border-top: 1px dashed #d9d5d5;
            border-bottom: 1px dashed #d9d5d5;
            .title{
                margin-right: 60px;
                color: #666666;
                font-size: 16px;
            }
        }
        .submit-btn{
            padding: 12px 55px;
        }
    }
}

.seize{
    opacity: 0;
}
.box-card-header {
    /deep/.el-page-header__left{
        width: 5%;
    }
    /deep/.el-page-header__content{
        width: 95%;
        display: flex;
        justify-content: space-between;
    }
}
</style>